export default "__VITE_ASSET__48fad780__"